/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5", "key": "svg-0" }]];
const IconRotateClockwise = createReactComponent("outline", "rotate-clockwise", "RotateClockwise", __iconNode);

export { __iconNode, IconRotateClockwise as default };
//# sourceMappingURL=IconRotateClockwise.mjs.map
